<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » スタッフ情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>スタッフ情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-user.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Filter・属性
        </div>
        <div class="manual-explain">
          スタッフ一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: ID、メールアドレス、名称、詳細
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> QRリーダーサイトURLコピーボタン
        </div>
        <div class="manual-explain">
          クリックすることでスタッフが利用するQRリーダーサイトのURLをクリップボードにコピーします。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> スタッフ一覧
        </div>
        <div class="manual-explain">
          登録済みのスタッフ情報の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Staff Information
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Staff Information</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-user.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the staff list.<br>
          *Filtering targets: ID, Email Address, Name, Detail
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> QR Reader Site URL Copy Button
        </div>
        <div class="manual-explain">
          Click to copy the QR reader site URL used by staff to the clipboard.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Add Button
        </div>
        <div class="manual-explain">
          Click to display the add screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Delete Button
        </div>
        <div class="manual-explain">
          Click to delete the selected information.<br>
          The button is activated by checking the delete checkboxes in the list.
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Staff List
        </div>
        <div class="manual-explain">
          Displays a list of registered staff information.<br>
          Click the edit icon to display the edit screen.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
